import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuardService } from 'app/main/pages/authentication/auth-guard.service';
import { AddOnsComponent } from './add-ons.component';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material';
import { MaterialModule } from 'app/shared/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ProjectCreateModule } from '../../project-create.module';
const routes = [
  { path: '', redirectTo: 'add-ons', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'add-ons', component: AddOnsComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  declarations: [AddOnsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatTooltipModule,
    MaterialModule,
    FlexLayoutModule,
    ProjectCreateModule
  ]
})
export class AddOnsModule { }
